/*
 * @link https://www.humhub.org/
 * @copyright Copyright (c) 2017 HumHub GmbH & Co. KG
 * @license https://www.humhub.com/licences
 *
 */

import {menu} from './menu'

const upload = {
    id: 'upload',
    menu:  (context) => menu(context)
};

export default upload;
